import React from 'react'
import { FormControlLabel, Checkbox, FormHelperText, FormControl, Tooltip, IconButton } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { get } from 'lodash'

const FormikCheckboxField = ({ formik, name, label, helperText }) => {
  const value = get(formik.values, name, false)
  const hasError = formik.touched[name] && Boolean(formik.errors[name])
  const errorText = hasError ? formik.errors[name] : ''

  return (
    <FormControl error={hasError}>
      <FormControlLabel
        control={
          <Checkbox
            id={name}
            name={name}
            checked={value}
            onChange={(event) => {
              formik.setFieldValue(name, event.target.checked)
            }}
            onBlur={formik.handleBlur}
          />
        }
        label={
          <>
            {label}
            {helperText && (
              <Tooltip title={helperText} arrow>
                <IconButton size="small" sx={{ ml: 0.5, p: 0 }}>
                  <InfoOutlinedIcon fontSize="small" color="action" />
                </IconButton>
              </Tooltip>
            )}
          </>
        }
      />
      {errorText && <FormHelperText>{errorText}</FormHelperText>}
    </FormControl>
  )
}

export default FormikCheckboxField
